import * as React from "react";
import { forwardRef } from "react";
const SvgIcChevron24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0617 12.0001L16.8114 18.7501L15.5008 20.0608L7.9707 12.5304L7.9707 11.4698L15.5008 3.93945L16.8114 5.25009L10.0617 12.0001Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcChevron24);
export { ForwardRef as ReactComponent };
